import { api } from '../api';

export const suggestionService = {
  async fetchSuggestions(params) {
    return api.get('suggestions', { params });
  },

  async fetchSuggestion(id) {
    return api.get('suggestions/' + id );
  },

  async createSuggestion(params) {
    return api.post('suggestions', params);
  },
};